import { connect } from 'react-redux';

import { Step } from 'src/app/components/Pages/GetStarted/StepLayout/Step';
import { setCurrentOnboardingStep } from 'src/app/state/actions';
import type { Dispatch, RootState } from 'src/app/state/store';

import { STEP_NAME } from '../StepLayout/consts';
import { StepCountHeight } from '../styles';

import { JoinWaitListForm } from './JoinWaitListForm';

const JoinWaitList = ({ setShowHorizontalProgressBar, goToWelcomeStep, zipCode }) => {
  setShowHorizontalProgressBar(false);
  const renderText = (
    <>We’re coming to {zipCode || 'you'} soon. Let’s stay in touch and we’ll let you know when we arrive!</>
  );

  return (
    <>
      <StepCountHeight />
      <Step title="Get early access" text={renderText} hideCount={true} handlePrev={goToWelcomeStep}>
        <JoinWaitListForm isGettingStartedForm />
      </Step>
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  zipCode: state?.onboardingForm?.zipCode,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goToWelcomeStep: () => dispatch(setCurrentOnboardingStep(STEP_NAME.WELCOME)),
});

const ConnectedJoinWaitList = connect(mapStateToProps, mapDispatchToProps)(JoinWaitList);

export { ConnectedJoinWaitList as JoinWaitList };
